// extracted by mini-css-extract-plugin
module.exports = {"infoblock":"infoblock_infoblock__BGbm0","error":"infoblock_error__RgUr_","warning":"infoblock_warning__I3Iwi"};